import { render, staticRenderFns } from "./faceDetectionPersonalitiesMain.vue?vue&type=template&id=8c9ecd8a&scoped=true"
import script from "./faceDetectionPersonalitiesMain.vue?vue&type=script&lang=js"
export * from "./faceDetectionPersonalitiesMain.vue?vue&type=script&lang=js"
import style0 from "./faceDetectionPersonalitiesMain.vue?vue&type=style&index=0&id=8c9ecd8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ecd8a",
  null
  
)

export default component.exports